import React from 'react';
import PropTypes from 'prop-types';
import appConfig from '@nerdwallet/app-config';

import {
  Box,
  Stack,
  Title,
  Text,
  Type,
  Modal,
  Link,
  Card,
} from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import LinkedInIcon from './linkedin-icon';

import styles from './people.module.less';

const CompanyPeopleTileWide = ({
  blurb,
  description,
  education,
  experience,
  featuredIn,
  firstName,
  image,
  imageMobile,
  imageAlt,
  isSpecialist,
  jobTitle,
  linkedInLink,
  name,
  specialties,
  title,
}) => {
  const [modalOpen, setOpen] = React.useState(false);
  const toggleOpen = () => setOpen((open) => !open);
  const linkedInAria = `Find ${name} on LinkedIn`;
  const containerLayout = isSpecialist
    ? styles.peopleContainerWideThreePerRow
    : styles.peopleContainerWide;

  return (
    <React.Fragment>
      <Modal
        className={styles.peopleModal}
        isOpen={modalOpen}
        onRequestClose={toggleOpen}
        titleElementId={name}
        trigger={
          <Card
            primary
            className={containerLayout}
            onClick={toggleOpen}
            component="div"
          >
            <Stack spacing="1" className={styles.peopleContentWide}>
              {image && (
                <Image
                  alt={imageAlt}
                  naturalHeight={266}
                  naturalWidth={454}
                  placeholdercolor="transparent"
                  className={styles.peopleContentImage}
                  src={`${appConfig.ASSETS_URL}/${image}`}
                />
              )}
              {name && (
                <Text size="large" bold>
                  {name}
                </Text>
              )}
              {!isSpecialist && title && <Text>{title}</Text>}
              {blurb && (
                <Text light>
                  {isSpecialist ? 'Expertise: ' : null}
                  {blurb}
                </Text>
              )}
              {name && (
                <Type size="1" bold uppercase color="blue" gotham>
                  More about {firstName}
                </Type>
              )}
            </Stack>
          </Card>
        }
      >
        <div className={styles.modalContainer}>
          <Box
            alignItems="center"
            display="flex"
            justifyContent="flex-start"
            marginBottom="3"
          >
            {imageMobile && (
              <Image
                alt={imageAlt}
                className={styles.modalImage}
                naturalWidth={111}
                naturalHeight={111}
                placeholdercolor="transparent"
                src={`${appConfig.ASSETS_URL}/${imageMobile}`}
              />
            )}
            <Stack spacing="1">
              {name && (
                <Title size="small" className={styles.modalName} component="h2">
                  {name}
                </Title>
              )}
              {!isSpecialist && title && <Text>{title}</Text>}
              {!isSpecialist && jobTitle && <Text>{jobTitle}</Text>}
              {isSpecialist && blurb && <Text light>{blurb}</Text>}
            </Stack>
          </Box>
          <div className={styles.peopleModalInner}>
            <Text>{description}</Text>
          </div>
          {isSpecialist ? (
            <Stack spacing="2" className={styles.specialistStack}>
              {education && (
                <Text>
                  <strong>Education:</strong> {education}
                </Text>
              )}
              {experience && (
                <Text>
                  <strong>Experience:</strong> {experience}
                </Text>
              )}
              {specialties && (
                <Text>
                  <strong>Specialties:</strong> {specialties}
                </Text>
              )}
              {featuredIn && (
                <Text>
                  <strong>Appearances: </strong>
                  {featuredIn}
                </Text>
              )}
            </Stack>
          ) : null}
          {linkedInLink && (
            <Box className={styles.socialLinks}>
              <div>
                <Link
                  href={linkedInLink}
                  className={styles.linkedInLink}
                  aria-label={linkedInAria}
                >
                  <LinkedInIcon />
                </Link>
              </div>
            </Box>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

CompanyPeopleTileWide.propTypes = {
  blurb: PropTypes.string,
  description: PropTypes.string,
  education: PropTypes.string,
  experience: PropTypes.string,
  featuredIn: PropTypes.string,
  firstName: PropTypes.string,
  image: PropTypes.string,
  imageMobile: PropTypes.string,
  imageAlt: PropTypes.string,
  isSpecialist: PropTypes.bool,
  jobTitle: PropTypes.string,
  linkedInLink: PropTypes.string,
  name: PropTypes.string,
  specialties: PropTypes.string,
  title: PropTypes.string,
};

CompanyPeopleTileWide.displayName = 'CompanyPeopleTileWide';

export default CompanyPeopleTileWide;
